import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.find-index";
import { getBatchRandom } from "@/utils/numUtils";
export var Radar = function Radar(cfg) {
  var outContainer = document.querySelector(cfg.el);
  var container = document.createElement("div");
  var cans = document.createElement("canvas");
  container.appendChild(cans);
  outContainer.appendChild(container);
  var ctx = cans.getContext("2d");
  var w = cfg.width;
  var h = cfg.height;
  container.style.position = "relative";
  container.style.width = w + "px";
  container.style.height = h + "px";
  cans.width = w;
  cans.height = h;
  var step = cfg.sideLength;
  var r = w / 2;
  ctx.lineWidth = 0.5;
  var arr = [0.3, 0.3, 0.3, 0.3, 0.3, 0.3];
  var result_arr = getBatchRandom(45, 95, 6);
  var times = 0;

  var run = function run() {
    var result = result_arr.map(function (v) {
      return v / 100;
    });
    var speed = result.map(function (v, index) {
      return Math.abs(v - arr[index]) / 10;
    });
    var max = Math.max.apply(null, speed);
    var max_index = speed.findIndex(function (v) {
      return v === max;
    });

    if (Math.abs(arr[max_index] - result[max_index]) > 0.001) {
      ctx.clearRect(0, 0, 300, 200);

      for (var i = 0; i < arr.length; i++) {
        if (arr[i] < result[i]) {
          arr[i] = arr[i] + speed[i];
        } else if (arr[i] > result[i]) {
          arr[i] = arr[i] - speed[i];
        }
      }

      for (var _i = 0; _i < step; _i++) {
        var rad = 2 * Math.PI / step * _i;

        var x = r + Math.sin(rad) * r * arr[_i];

        var y = r + Math.cos(rad) * r * arr[_i];

        ctx.lineTo(x, y);
      }

      ctx.closePath();
      ctx.fillStyle = '#A020F0';
      ctx.fill(); // ctx.stroke();
      //添加数据点
      // ctx.fillStyle = "#A020F0";

      ctx.beginPath();
      ctx.closePath();
    } else {
      times++;
      result_arr = getBatchRandom(45, 95, 6);
    }

    if (times < 40) {
      window.requestAnimationFrame(run);
    }
  };

  window.requestAnimationFrame(run); // for(let i=0;i<step;i++) {
  //     const rad = 2*Math.PI/step * i;
  //     const x = r + Math.sin(rad)*r*data[i][1];
  //     const y = r + Math.cos(rad)*r*data[i][1];
  //     ctx.lineTo(x,y);
  // }
  // ctx.closePath();
  // ctx.fillStyle = 'rgba(137, 104, 205, .4)';
  // ctx.fill();
  // ctx.stroke();
  //
  // //添加数据点
  // ctx.fillStyle = "#A020F0";
  // for(let i=0;i<step;i++) {
  //     const rad = 2*Math.PI/step * i;
  //     const x = r + Math.sin(rad)*r*data[i][1];
  //     const y = r + Math.cos(rad)*r*data[i][1];
  //     ctx.beginPath();
  //     ctx.arc(x,y,4,0,2*Math.PI);
  //     ctx.fill();
  //     ctx.closePath();
  // }
};
export var Sexangle = function Sexangle(cfg) {
  var outContainer = document.querySelector(cfg.el);
  var container = document.createElement("div");
  var cans = document.createElement("canvas");
  container.appendChild(cans);
  outContainer.appendChild(container);
  var ctx = cans.getContext("2d");
  var w = cfg.width;
  var h = cfg.height;
  container.style.position = "relative";
  container.style.width = w + "px";
  container.style.height = h + "px";
  cans.width = w;
  cans.height = h;
  var step = cfg.sideLength;
  var r = w / 2;
  ctx.lineWidth = 0.5; //绘制网格背景

  for (var s = 4; s > 0; s--) {
    ctx.beginPath();

    for (var i = 0; i < step; i++) {
      var rad = 2 * Math.PI / step * i;
      var x = r + Math.sin(rad) * r * (s / 4);
      var y = r + Math.cos(rad) * r * (s / 4);
      ctx.lineTo(x, y);
    }

    ctx.closePath();
    ctx.strokeStyle = '#B8B8B8';
    ctx.fillStyle = 'transparent';
    ctx.stroke();
  } //绘制伞骨


  ctx.beginPath();

  for (var _i2 = 0; _i2 < step; _i2++) {
    var _rad = 2 * Math.PI / step * _i2;

    var _x = r + Math.sin(_rad) * r;

    var _y = r + Math.cos(_rad) * r;

    ctx.moveTo(r, r);
    ctx.lineTo(_x, _y);
    var text = document.createElement("div"); // text.innerHTML = data[i][0];

    text.style.position = "absolute"; //添加文本

    if (_x > r) {
      text.style.left = _x + 10 + 'px';
    } else {
      text.style.right = w - _x + 5 + 'px';
    }

    if (_y > r) {
      text.style.top = _y + 'px';
    } else {
      text.style.bottom = h - _y + 'px';
    }

    container.appendChild(text);
  }

  ctx.strokeStyle = "#e0e0e0";
  ctx.setLineDash([3]);
  ctx.stroke(); //绘制折线

  ctx.strokeStyle = "#9766FF";
  ctx.setLineDash([]);
  ctx.beginPath();
};